//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import utils from "@/utils"
import api from "@/api"
import {Message} from 'element-ui';
import { setTimeout } from 'timers';
 var isIos = !!navigator.userAgent.match(/\(i[^;]+;( U;)? CPU.+Mac OS X/); //ios终端
export default {
    props:['classid','num','isText'],
    data() {
        return {
            buttonToggle2:1,
            dialogVisible2:false,
            courseId:'',
            id:'',
            dialogVisible:false,
            alertType:1,
            alerttext:'',
            buttonToggle:1,
            checkList:[],     
            showType:1,
            // videoWidth: 430,
            videoWidth: window.screen.width,
            videoHeight: window.screen.width,
            imgSrc: "",
            thisCancas: null,
            thisContext: null,
            thisVideo: null,
            isIos:null,
        };
    },
    created () {
        //判断是不是
        this.isIos = isIos
        this.$on('bridge',(val)=>{
            if (val) { //
                this.buttonToggle = 1
                this.checkList = []
            } else {
                if (this.isIos) { //ios设备
                    this.buttonToggle = 2
                }
            }
             this.dialogVisible2 = true
        });
    },
  mounted() {
  },
  methods: {
       closeFace () {
          this.dialogVisible2 = false
      },
       rzxy () {
           this.$router.push({name: 'consentM',query:{id:this.classid}})
        
      },
      chnageCheckbox (val) {
           if (this.isIos) {
                if (val.length > 0) {
                    this.buttonToggle = 2
                } else {
                    this.buttonToggle = 1
                }
            }
      },
       updateFace(e) {
            const file = e.target.files[0] || e.dataTransfer.files[0]
            var imgUrlBase64
            if (file) {
                let _this = this
                var reader = new FileReader()
               reader.readAsDataURL(file);
                reader.onload = function (evt){
                    var imgBase64Data  = evt.target.result;//这一步是关键
                    _this.axios.post(api.Upload3,{
                        // "isexam":_this.isText,
                        "base64":imgBase64Data,
                        // "classid": _this.classid
                    }).then((res) => {
                        if (res.data.code == 200) {
                            _this.dialogVisible2 = false
                            if (_this.isText) { //考试验证
                                _this.$emit('addnum2')
                            } else { //人脸对比
                                _this.$emit('addnum')
                            }
                        } else {
                            _this.alert(1,res.data.msg)
                        }
                    }).catch((res) =>{
                        _this.alert(1,'认证失败,请重新认证')
                    })
                   
                }
            }
        },
       alert (type,text) {
            this.dialogVisible = true
            this.alertType = type
            this.alerttext = text
        },
      handleClose () {

      },
        agreeBtn () {
            if (this.checkList.length > 0) { //同意
                if (!this.isIos) { //安卓
                    this.showType = 2
                    setTimeout(() => {
                        this.getCompetence()
                    },0)
                } else { //ios
                    this.buttonToggle = 2
                }
            } else {
                this.alert(1,'请勾选我已仔细阅读并同意')
            }
        },
        // base64转文件
        dataURLtoFile(dataurl, filename) {
            var arr = dataurl.split(",");
            var mime = arr[0].match(/:(.*?);/)[1];
            var bstr = atob(arr[1]);
            var n = bstr.length;
            var u8arr = new Uint8Array(n);
            while (n--) {
                u8arr[n] = bstr.charCodeAt(n);
            }
            return new File([u8arr], filename, { type: mime });
        },
          // 调用权限（打开摄像头功能）
        getCompetence() {
            this.buttonToggle2 = 1
            var _this = this;
            this.thisCancas = document.getElementById("canvasCamera");
            this.thisContext = this.thisCancas.getContext("2d");
            this.thisVideo = document.getElementById("videoCamera");
            // 旧版本浏览器可能根本不支持mediaDevices，我们首先设置一个空对象
            if (navigator.mediaDevices === undefined) {
                navigator.mediaDevices = {};
            }
            // 一些浏览器实现了部分mediaDevices，我们不能只分配一个对象
            // 使用getUserMedia，因为它会覆盖现有的属性。
            // 这里，如果缺少getUserMedia属性，就添加它。
            if (navigator.mediaDevices.getUserMedia === undefined) {
                navigator.mediaDevices.getUserMedia = function (constraints) {
                // 首先获取现存的getUserMedia(如果存在)
                var getUserMedia =
                    navigator.webkitGetUserMedia ||
                    navigator.mozGetUserMedia ||
                    navigator.getUserMedia;
                // 有些浏览器不支持，会返回错误信息
                // 保持接口一致
                if (!getUserMedia) {
                    return Promise.reject(
                    new Error("getUserMedia is not implemented in this browser")
                    );
                }
                // 否则，使用Promise将调用包装到旧的navigator.getUserMedia
                return new Promise(function (resolve, reject) {
                    getUserMedia.call(navigator, constraints, resolve, reject);
                });
                };
            }
            var constraints = {
                audio: false,
                video: {
                   
                    facingMode:'user'
                },
            };
            navigator.mediaDevices
                .getUserMedia(constraints)
                .then(function (stream) {
                    // 旧的浏览器可能没有srcObject
                    if ("srcObject" in _this.thisVideo) {
                        _this.thisVideo.srcObject = stream;
                    } else {
                        // 避免在新的浏览器中使用它，因为它正在被弃用。
                        _this.thisVideo.src = window.URL.createObjectURL(stream);
                    }
                    _this.thisVideo.onloadedmetadata = function (e) {
                        _this.thisVideo.play();
                    };
                })
                .catch((err) => {
                    // alert('不支持')
                });
        },
          //  绘制图片（拍照功能）
        setImage() {
            var _this = this;
            // 点击，canvas画图
            _this.thisContext.drawImage(
                _this.thisVideo,
                0,
                0,
                _this.videoWidth,
                _this.videoHeight
            );
            // 获取图片base64链接
            var image = this.thisCancas.toDataURL("image/jpeg");

            this.stopNavigator();
            this.axios.post(api.Upload3,{
                // "isexam":this.isText,
                "base64":image,
                // "classid": this.classid
            }).then((res) => {
                if (res.data.code == 200) {
                    this.dialogVisible2 = false
                    this.showType = 0
                    if (this.isText) { //考试验证
                        this.$emit('addnum2')
                    } else { //人脸对比
                        this.$emit('addnum')
                    }
                    // Message.success({
                    //     message:'认证成功',
                    // });
                } else {
                    this.buttonToggle2 = 2
                }
            }).catch((res) =>{
                this.buttonToggle2= 2
            })
        //   _this.imgSrc = image;
        //   this.$emit("refreshDataList", this.imgSrc);
        },
        // base64转文件
        dataURLtoFile(dataurl, filename) {
            var arr = dataurl.split(",");
            var mime = arr[0].match(/:(.*?);/)[1];
            var bstr = atob(arr[1]);
            var n = bstr.length;
            var u8arr = new Uint8Array(n);
            while (n--) {
                u8arr[n] = bstr.charCodeAt(n);
            }
            return new File([u8arr], filename, { type: mime });
        },
        // 关闭摄像头
        stopNavigator() {
            this.thisVideo.srcObject.getTracks()[0].stop();
        },
    },
};



// WEBPACK FOOTER //
// ./src/components/mobile/FaceMobile.vue